export default __webpack_public_path__ + "locales/sr-Cyrl-RS/FormFillingTipsDialog.json?hash=7db6a92575e541c891e5c64335bc6f1b";